import { createAction, SILENT } from 'uix/actions';
// maybe handle simple signal with saga
export let saveMods = createAction('SAVE_MODS', (otid, text)=>({
        otid,
        text
    }));
export let saveModsSuccess = createAction('SAVE_MODS_SUCCESS', (otid, text)=>({
        otid,
        text
    }));
export let setModsFormValue = createAction('SET_MODS_FORM_VALUE', (uid, fpath, value)=>({
        uid,
        fpath,
        value
    }));
